import React from "react";
// import Table from "rc-table";
import DataTable, { createTheme } from "react-data-table-component";

import {
  formatName,
  numberWithCommas,
  abbreviateNumber,
} from "helpers/miscHelpers";

createTheme("myDark", {
  text: {
    primary: "#ccc",
    secondary: "#2aa198",
  },
  background: {
    default: "rgba(40, 40, 40, 1)",
  },
  context: {
    background: "#cb4b16",
    text: "#FFFFFF",
  },
  divider: {
    default: "rgba(102, 33, 134, 0.4)",
  },
  button: {
    default: "#2aa198",
    hover: "rgba(0,0,0,.08)",
    focus: "rgba(255,255,255,.12)",
    disabled: "rgba(0,0,0,.12)",
  },
  sortFocus: {
    default: "#2aa198",
  },
  highlightOnHover: {
    default: "#EEEEEE",
    text: "rgba(0, 0, 0, 0.87)",
  },
  striped: {
    default: "rgba(60, 60, 60, 0.5)",
    text: "#ccc",
  },
});

const columns = [
  {
    name: "State",
    selector: "name",
    sortable: true,
    format: (row) => `${formatName(row.name)}`,
  },
  {
    name: "Total Cases",
    selector: "cases",
    sortable: true,
    format: (row) => `${numberWithCommas(row.cases)}`,
    right: true,
  },
  {
    name: "New Cases",
    selector: "newCases",
    sortable: true,
    format: (row) => `${numberWithCommas(row.newCases)}`,
    right: true,
    conditionalCellStyles: [
      {
        when: (row) => row.newCases > 1000,
        style: {
          backgroundColor: "rgba(220,50,50, 0.9)",
          color: "#111",
          "&:hover": {
            cursor: "pointer",
          },
        },
      },
      {
        when: (row) => row.newCases > 500,
        style: {
          backgroundColor: "rgba(220,50,50, 0.6)",
          color: "#111",
          "&:hover": {
            cursor: "pointer",
          },
        },
      },
      {
        when: (row) => row.newCases > 100,
        style: {
          backgroundColor: "rgba(220,50,50, 0.3)",
          color: "#111",
          "&:hover": {
            cursor: "pointer",
          },
        },
      },
      {
        when: (row) => row.newCases <= 100,
        style: {
          backgroundColor: "rgba(220,50,50, 0.1)",
          color: "#111",
          "&:hover": {
            cursor: "pointer",
          },
        },
      },
      {
        when: (row) => row.newCases <= 50,
        style: {
          backgroundColor: "rgba(50, 192, 52, 0.05)",
          color: "#111",
          "&:hover": {
            cursor: "pointer",
          },
        },
      },
      {
        when: (row) => row.newCases < 20,
        style: {
          backgroundColor: "rgba(50, 192, 52, 0.1)",
          color: "#111",
          "&:hover": {
            cursor: "pointer",
          },
        },
      },
      {
        when: (row) => row.newCases < 10,
        style: {
          backgroundColor: "rgba(50, 192, 52, 0.25)",
          color: "#111",
          "&:hover": {
            cursor: "pointer",
          },
        },
      },
    ],
  },
  {
    name: "Total Deaths",
    selector: "deaths",
    sortable: true,
    format: (row) => `${numberWithCommas(row.deaths)}`,
    right: true,
  },
  {
    name: "New Deaths",
    selector: "newDeaths",
    sortable: true,
    format: (row) => `${numberWithCommas(row.newDeaths)}`,
    right: true,
  },
  {
    name: "Cases per 100K",
    selector: "casesPer100k",
    sortable: true,
    format: (row) => `${abbreviateNumber(row.casesPer100k, 3)}`,
    right: true,
  },
  {
    name: "Deaths per 100K",
    selector: "deathsPer100k",
    sortable: true,
    right: true,
    format: (row) => `${abbreviateNumber(row.deathsPer100k, 3)}`,
  },
];

const MyDataTable = ({ data }) => {
  const latestDate = Object.keys(data[0].timeline.cases)
    .filter((x) => x.includes("/"))
    .slice(-1)[0];

  const arrangedData = data.map((d, i) => {
    const tempObj = {
      name: d.name,
      cases: d.timeline.cases[`${latestDate}`],
      deaths: d.timeline.deaths[`${latestDate}`],
      newCases: d.timeline.newCases[`${latestDate}`],
      newDeaths: d.timeline.newDeaths[`${latestDate}`],
      casesPer100k: d.timeline.casesPer100k[`${latestDate}`],
      deathsPer100k: d.timeline.deathsPer100k[`${latestDate}`],
      key: i,
    };
    return tempObj;
  });

  return (
    <DataTable
      columns={columns}
      data={arrangedData}
      title={`Daily Data For: ${latestDate}`}
      striped
      // theme="myDark"
      noHeader
    />
  );
};

export default MyDataTable;
